import React from 'react';
import FormGroupSelectInput from "../formGroupSelectInput";
import CenteredDots from "../General/centeredDots";

const TobaAllocation = (props) => {
    return (
        <div>
            <FormGroupSelectInput
                Disabled={props.fetchingTobas}
                Label="TOBA"
                LeftWrapper="col-sm-3"
                Value={props.selectedToba}
                Name="selectedToba"
                HandleInputChange={(evt) => props._changeSelectedToba(evt.target.value)}
                Options={props.tobaSelectOptions}
                CenterWrapper="col-sm-8 formGroupSelectInput-select-wrapper"
                RightWrapper=""
                Required={true}
                SelectStyle={'form-control formGroupSelectInput-select'}

            />
            {
                props.fetchingTobas?
                    <CenteredDots/>
                    :
                    null
            }
        </div>
    )
};

export default TobaAllocation;